import { render, staticRenderFns } from "./OrderReportTable.vue?vue&type=template&id=7595a2e6&"
import script from "./OrderReportTable.vue?vue&type=script&lang=js&"
export * from "./OrderReportTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports